var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.poolComponent,{tag:"component",attrs:{"id":_vm.id,"pid":_vm.pid,"type":_vm.type},on:{"reload-data":_vm.loadData}})}
var staticRenderFns = []

export { render, staticRenderFns }